'use strict';

module.exports = function (OCL) {
    var originalToSVG = OCL.Molecule.prototype.toSVG;
    return function (width, height, id, options) {
        options = options || {};
        var svg = originalToSVG.call(this, width, height, id, options);

        if (options.bold) {
            svg = svg.replace(/font-family=" Helvetica" /g, 'font-family=" Helvetica" font-weight="bold" ');
        }
        if (options.strokeWidth) {
            svg = svg.replace(/stroke-width:1/g, `stroke-width:${options.strokeWidth}`);
        }
        return svg;
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/openchemlib-extended/lib/extend/toSVG.js
// module id = 57
// module chunks = 0